// removed by extract-text-webpack-plugin
module.exports = {"login-page":"login-page__zIF09","login-box":"login-box__1O-S6","login-form":"login-form__uH3jF","sub-header":"sub-header__OqV8f","edit-email":"edit-email__1Wk_L","header":"header__177ox","subheader":"subheader__2_skT","point":"point__2nHeW","point-image":"point-image__nuSeg","point-detail":"point-detail__A5JXc","disabled":"disabled__1SxRk","hidden":"hidden__aF_9H","login-content":"login-content__auQ77"};


//////////////////
// WEBPACK FOOTER
// ./styles/login.scss
// module id = 1206
// module chunks = 68